import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import Page from "../Page/Page";
import "../../Styles/chap-version.css";
import { useState } from "react";
import { Transaction_Book } from "../../Connections/Transaction";
import Toast from "../../Utils/Toast";

const PrintedVersion = (props) => {
  const navigator = useNavigate();

  //===================== states ======================
  const [physicalBookList, setPhysicalBookList] = useState([]);
  const [purchasedBooks, setPurchasedBooks] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState(null);
  const [codeValue, setCodeValue] = useState(null);

  const [disableBtn, setDisableBtn] = useState(false);
  //===================== books querys ======================

  useEffect(() => {
    //get available book list
    Transaction_Book.GetPhysicalBookList()
      .then((res) => {
        if (res[0]) {
          setPhysicalBookList(res[2].data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    //purchased books
    Transaction_Book.GetPhysicalPurchasedBooks()
      .then((res) => {
        if (res[0]) {
          setPurchasedBooks(res[2].data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //add physical book
  const handleAddPhysicalBook = () => {
    const data = {
      bookId: selectedBookId,
      code: codeValue,
    };
    if (selectedBookId !== null && codeValue !== null) {
      setDisableBtn(true);
      Transaction_Book.AddPhysicalBook(data)
        .then((res) => {
          if (res[0]) {
            Toast("success", res[1]);
            setDisableBtn(false);
          } else {
            Toast("error", res[1]);
            setDisableBtn(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setDisableBtn(false);
        });
    } else {
      if (selectedBookId === null && codeValue === null) {
        return Toast(
          "error",
          "لطفا کتاب را انتخاب نمایید|لطفا کد پشت جلد کتاب را وارد نمایید"
        );
      }
      if (codeValue === null) {
        return Toast("error", "لطفا کد پشت جلد کتاب را وارد نمایید");
      }
      if (selectedBookId === null) {
        return Toast("error", "لطفا کتاب را انتخاب نمایید");
      }
    }
  };

  return (
    <Page>
      <MobileNavBar text="پروفایل" action={() => navigator("/profile")} />
      <div className="chapVersion_wrapper">
        <div
          className="News_back-arrow mobile-hidden"
          onClick={() => navigator("/profile")}
          style={{ marginTop: "-20px" }}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        {/* filter books  */}
        <div className="filter-box-parent">
          <div className="filter-Box">
            <div className="title-box">
              <img src="imgs/Profile/chapVersion.svg" />
              <p> کد و عنوان کتابی که خریدی رو اینجا وارد کن:</p>
            </div>
            {/* input 1  */}
            <div
              style={{ width: "100%" }}
              className="Login_wrapper-right-side-container-form first-input"
            >
              <input
                type="tel"
                maxLength={12}
                required
                className={`Login_wrapper-right-side-container-form-input-number`}
                value={codeValue}
                onChange={(e) =>
                  isNaN(e.target.value) ? null : setCodeValue(e.target.value)
                }
              />
              <p
                className={`Login_wrapper-right-side-container-form-item-label`}
              >
                کد کتاب
              </p>
            </div>
            {/* input 2  */}
            <div
              style={{ width: "100%" }}
              className="Login_wrapper-right-side-container-form border-select"
            >
              <select
                style={{
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  direction: "rtl",
                }}
                className="Login_wrapper-right-side-container-form-input-number b-none"
                name="cars"
                id="cars"
                onChange={(e) => setSelectedBookId(Number(e.target.value))}
              >
                <option value="">انتخاب کنید</option>
                {physicalBookList.map((item, index) => {
                  return (
                    <option key={item.bookId} value={item.bookId}>
                      {item.bookName}
                    </option>
                  );
                })}
              </select>
              <p
                className={`Login_wrapper-right-side-container-form-item-label`}
              >
                عنوان کتاب
              </p>
            </div>
          </div>
          <div className="parent-submit-book">
            <button
              disabled={disableBtn}
              onClick={handleAddPhysicalBook}
              className={`Actionmodal-inside-form-btn ${
                disableBtn && "disabled-form-btn"
              }`}
              type="submit"
            >
              ارسال
            </button>
          </div>
        </div>
        {/* <div></div> */}
        <div className="available-books-parent">
          <div className="available-books-title">
            <span>کتاب‌های ثبت شده</span>
            <hr />
          </div>
          <div className="available-books-content">
            {/* book item */}
            {purchasedBooks.map((item, index) => {
              return (
                <div key={item.bookId} className="available-books-item">
                  <p className="text-title">{item.bookName}</p>
                  <div className="available-books-details">
                    <div className="text-parent">
                      <p className="text-label">تاریخ ثبت</p>
                      <p className="text-value">{item.date}</p>
                    </div>
                    <div className="text-parent">
                      <p className="text-label">امتیاز دریافتی</p>
                      <p className="text-value">{item.score}</p>
                    </div>
                    <div className="text-parent">
                      <p className="text-label">سکه دریافتی</p>
                      <p className="text-value">{item.coin}</p>
                    </div>
                    <div className="text-parent">
                      <p className="text-label">کد کتاب</p>
                      <p className="text-value">{item.code}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default PrintedVersion;
